// extracted by mini-css-extract-plugin
export default {"modal-container":"MessageModal_modal-container__BSS36","modal":"MessageModal_modal__q16O2","error":"MessageModal_error__f4XFg"};